import { render } from "./FamilyCard.vue?vue&type=template&id=8d7c3f5e"
import script from "./FamilyCard.vue?vue&type=script&lang=js"
export * from "./FamilyCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__